import React, { Component } from 'react'

import Recaptcha from 'react-google-recaptcha'

import Link from '../utils/link'

import parse from 'html-react-parser'

const RECAPTCHA_KEY = "6Lc_mi0iAAAAAPxvjkOBguy-Y9VKzHpmRV6HIGSi"  

class Form extends Component {

  state = {
    form: {},
  }

  constructor(props) {
    super(props)
    this.form = React.createRef();
  }

  handleChange = e => {
    let { form } = this.state
    if (e.target.name === 'type') {
      let current = form[e.target.name] || ''
      if (current.indexOf(e.target.value) === -1) {
        // add
        form[e.target.name] = current + ' ' + e.target.value
      } else {
        // remove
        form[e.target.name] = current.replace(' ' + e.target.value, '')
      }
    } else {
      form[e.target.name] = e.target.value
    }
    this.setState({ form })
  }

  handleRecaptcha = value => {
    this.setState({ "g-recaptcha-response": value });
  }

  handleSubmit = async e => {
    e.preventDefault()
    if (!this.form.current.checkValidity()) return false


    const formData = new FormData(this.form.current)
    formData.append('form-name', this.form.current.getAttribute("name"))
    const queryString = new URLSearchParams(formData).toString()

    await fetch("https://hooks.zapier.com/hooks/catch/2181815/39qnwwf/?" + queryString)

    this.setState({result: 'success'})

  }

  render() {

    let { title, content } = this.props

    let props = {
      ref: this.form,
      name: 'advocacy_download',
      onSubmit: this.handleSubmit,
    }

    if (this.state.result === 'success') {
      return (
        <div className="signup__nav">
          <p>Thanks for getting in contact with us.<br /> A member of our team will be in touch soon.</p>
        </div>
      )
    }

    return (
      <div className="signup__nav">
        <h4>{parse(title)}</h4>
        <div className='signup__nav-content'>{parse(content)}</div>
        <form {...props}>
          <input type='hidden' name='source' value='advocacy_download' />
          <p>Which best describes you?</p>
          <ul>
            <li>
              <input id={`advocacy_buyer`} className='boxes' type='checkbox' name="advocacy_buyer" onChange={this.handleChange} /> 
              <label htmlFor={`advocacy_buyer`}>
                I’m a Buyer
              </label>
            </li>
            <li>
              <input id={`advocacy_seller`} className='boxes' type='checkbox' name="advocacy_seller" onChange={this.handleChange} />
              <label htmlFor={`advocacy_seller`}>
                I’m a Seller
              </label>
            </li>
            <li>
              <input id={`advocacy_curious`} className='boxes' type='checkbox' name="advocacy_curious" onChange={this.handleChange} />
              <label htmlFor={`advocacy_curious`}>
                I'm just curious
              </label>
            </li>
            <li>
              <input id={`advocacy_other`} className='boxes' type='checkbox' name="advocacy_other" onChange={this.handleChange} />
              <label htmlFor={`advocacy_other`}>
                Other
              </label>
            </li>
          </ul>
          <div className='signup__double'>
            <input type='text' name='fname' placeholder='First Name' onChange={this.handleChange} required />
            <input type='text' name='lname' placeholder='Last Name' onChange={this.handleChange} required />
          </div>
          <input type='email' name='email' placeholder='Email' onChange={this.handleChange} required />
          <div className='recaptcha__wrapper'>
            <Recaptcha
              ref='recaptcha'
              sitekey={RECAPTCHA_KEY}
              onChange={this.handleRecaptcha}
            />
          </div>
          <button className="contactbtn" type='submit'>Get your free guide</button>
          { this.state.result !== '' &&
            <p className="paragraph" dangerouslySetInnerHTML={{ __html: this.state.msg }} />
          }
        </form>
      </div>  
    )
  }
}

class AdvocacyDownload extends Component {

  render() {
    const { image, title, content } = this.props

    return (
      <>
        <section className='advocacy-download' data-color="#FFFFFF" id='download'>
          <div className="advocacy-download__inner">
            <div className='advocacy-download__image'>
              <img src={image.localFile.publicURL} alt={title} />
            </div>
            <div className='advocacy-download__form'>
              <Form title={title} content={content} />
            </div>
          </div>
        </section>
        <section className='advocacy-footer' id="contact">
          <div className='advocacy-footer__inner'>
            <div className='advocacy-footer__left'>
              <div>
                <h4>Contact Us</h4>
                <ul>
                  <li>
                    <Link to='mailto:martin@whitefoxrealestate.com'>
                      <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" clipRule="evenodd" d="M0.0657959 4.71484H8.56343V5.81116H0.0657959V4.71484Z" fill="#64656A"/>
                        <path fillRule="evenodd" clipRule="evenodd" d="M6.2063 8.93666L5.43842 8.16878L8.34447 5.26325L5.43842 2.35773L6.2063 1.58984L9.87919 5.26326L6.2063 8.93666Z" fill="#64656A"/>
                      </svg>
                      <span>Email WHITEFOX</span>
                    </Link>
                  </li>
                  <li>
                    <Link to='tel:+61390684850'>
                      <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" clipRule="evenodd" d="M0.0657959 4.71484H8.56343V5.81116H0.0657959V4.71484Z" fill="#64656A"/>
                        <path fillRule="evenodd" clipRule="evenodd" d="M6.2063 8.93666L5.43842 8.16878L8.34447 5.26325L5.43842 2.35773L6.2063 1.58984L9.87919 5.26326L6.2063 8.93666Z" fill="#64656A"/>
                      </svg>
                      <span>+61 3 9068 4850</span>
                    </Link>
                  </li>
                </ul>
              </div>
              <div>
                <ul>
                  <li>
                    <Link to='tel:+61396459699'>
                      <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" clipRule="evenodd" d="M0.0657959 4.71484H8.56343V5.81116H0.0657959V4.71484Z" fill="#64656A"/>
                        <path fillRule="evenodd" clipRule="evenodd" d="M6.2063 8.93666L5.43842 8.16878L8.34447 5.26325L5.43842 2.35773L6.2063 1.58984L9.87919 5.26326L6.2063 8.93666Z" fill="#64656A"/>
                      </svg>
                      <span>WHITEFOX HQ</span>
                    </Link>
                  </li>
                  <li>
                    <Link to='tel:+61396459699'>
                      <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" clipRule="evenodd" d="M0.0657959 4.71484H8.56343V5.81116H0.0657959V4.71484Z" fill="#64656A"/>
                        <path fillRule="evenodd" clipRule="evenodd" d="M6.2063 8.93666L5.43842 8.16878L8.34447 5.26325L5.43842 2.35773L6.2063 1.58984L9.87919 5.26326L6.2063 8.93666Z" fill="#64656A"/>
                      </svg>
                      <span>PORT PHILLIP</span>
                    </Link>
                  </li>
                  <li>
                    <Link to='tel:+61390684850'>
                      <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" clipRule="evenodd" d="M0.0657959 4.71484H8.56343V5.81116H0.0657959V4.71484Z" fill="#64656A"/>
                        <path fillRule="evenodd" clipRule="evenodd" d="M6.2063 8.93666L5.43842 8.16878L8.34447 5.26325L5.43842 2.35773L6.2063 1.58984L9.87919 5.26326L6.2063 8.93666Z" fill="#64656A"/>
                      </svg>
                      <span>STONNINGTON</span>
                    </Link>
                  </li>
                  <li>
                    <Link to='tel:+61396459699'>
                      <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" clipRule="evenodd" d="M0.0657959 4.71484H8.56343V5.81116H0.0657959V4.71484Z" fill="#64656A"/>
                        <path fillRule="evenodd" clipRule="evenodd" d="M6.2063 8.93666L5.43842 8.16878L8.34447 5.26325L5.43842 2.35773L6.2063 1.58984L9.87919 5.26326L6.2063 8.93666Z" fill="#64656A"/>
                      </svg>
                      <span>BAYSIDE</span>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className='advocacy-footer__right'>
              <Link className='btn' to='#register'>
                Register your interest
              </Link>
              <Link className='btn' to='#download'>
                Download a free guide
              </Link>
            </div>
          </div>
        </section>
      </>
    )
  }
}

export default AdvocacyDownload